/**
 * animate
 * @param {object} {timeout, from, to} - timeout: The length of time the animation should run, from: The starting value for the animation, to: The value the animation should finish at
 * @param {function} callback - A function that gets called on every animation from with the current value of the animation
 * @example
 * // Over 1 second will animate the width of an element from 0% to 100%
 * animate({timeout: 1000, from: 0, to: 100}, (width) => element.width = `${width}%`);
 */
const animate = ({ timeout, from, to }, callback) => {
  let startTime;
  const runAnimation = (timestamp) => {
    if (!startTime) {
      startTime = timestamp;
    }
    const currentPerc = (timestamp - startTime) / timeout;
    const currentVal = (to - from) * currentPerc;
    callback(currentVal);
    if (timestamp - startTime >= timeout) {
      callback(to);
      return;
    }
    return window.requestAnimationFrame(runAnimation);
  };
  window.requestAnimationFrame(runAnimation);
};

// Animate specifically from 0 to 100 over a given timeout
const animatePercentage = (timeout, callback) => {
  animate({ timeout, from: 0, to: 100 }, callback);
};

// Animate from the values but ease out
const animateEaseOut = ({ timeout, from, to }, callback) => {
  let currentFrom = from;
  animatePercentage(timeout, (currentPercentage) => {
    const distanceLeft = currentFrom - to;
    currentFrom -= distanceLeft * (currentPercentage / 100);
    callback(currentFrom);
  });
};

export { animate, animatePercentage, animateEaseOut };
